export function renderCompetencia(dataCompetencia: string): string {
  if (!dataCompetencia || dataCompetencia.length !== 6) return '';
  const ano = dataCompetencia.slice(0, 4);
  const mes = dataCompetencia.slice(4, 6);

  return `${mes}/${ano}`;
}

export function renderCompetenciaFromDate(dataCompetencia: Date): string {
  if (!dataCompetencia) return '';

  const date = new Date(dataCompetencia);

  if (isNaN(date.getTime())) return '';

  const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
  const ano = date.getUTCFullYear();

  return `${mes}/${ano}`;
}

export function formatCompetenciaToYYYYMM(data: string | Date): string {
  const date = new Date(data);

  const ano = date.getUTCFullYear();
  const mes = String(date.getUTCMonth() + 1).padStart(2, '0');

  return `${ano}${mes}`;
}

export function formatCompetenciaToYYYY(data: string | Date): string {
  const date = new Date(data);

  const ano = date.getUTCFullYear();
  return ano?.toString()
}